<template>
  <section class="print_page_1">
    <h1 align="center" class="title">領 収 書</h1>
    <div class="top_area">
      <div class="broker_name_area">
        <div class="name_area_flex">
          <div class="underline_area">
            <span class="broker_name">{{ requester.brokerage_company || requester.requested_by }}</span>
          </div>
          <span class="broker_honorifics">御中</span>
        </div>
      </div>
      <div class="issue_info_area">
        <span>No.</span>
        <span>{{ compactDate }}-{{ id }}-{{ receipt_issued_count }}</span>
        <div class="issue_date">
          <span>発行日 </span>
          <span>{{ formattedTodayDate }}</span>
        </div>
      </div>
    </div>
    <div class="price_area">
      <span class="text_bold">金額</span>
      <span class="text_bold">￥{{ billing_price.toLocaleString() }}-</span>
      <span>（税込）</span>
    </div>
    <div class="text_area">
      <p>
        <span>但 {{ building.name }} {{ building_house_number }}号室 {{ issueDocumentName }}</span>
        <span> 発行費用として</span>
        <br>
        <span>上記正に領収いたしました。</span>
      </p>
      <p class="first_issue_date" v-if="receipt_issued_status===$constant.RECEIPT_STATUS.RECEIPT_STATUS_REISSUE_DONE">初回発行日 : {{ formattedDate }}</p>
    </div>
    <div class="stamp_img_area">
      <img :src="building.management_company.receipt_stamp.path"
           class="stamp_img"
           v-if="building.management_company.receipt_stamp">
    </div>
    <div class="bottom_area">
      <div class="price_detail_area">
        <div v-if="building.management_company.use_invoice_number">
          <div class="detail_title">
            <span>内訳</span>
          </div>
          <div class="detail_area">
            <div class="detail_price_area">
              <div><span>合計</span></div>
              <div><span>￥{{ billing_price.toLocaleString() }}</span></div>
            </div>
            <span>内消費税</span>
            <span>（￥{{ tax_price.toLocaleString() }}）</span>
          </div>
          <div class="detail_area">
            <div class="detail_price_area">
              <div><span>10%対象</span></div>
              <div><span>￥{{ billing_price.toLocaleString() }}</span></div>
            </div>
            <span>内消費税</span>
            <span>（￥{{ tax_price.toLocaleString() }}）</span>
          </div>
        </div>
        </div>
      <div class="info_area">
        <span>{{ building.management_company.name }}</span>
        <br>
        <span>〒{{ formattedPostalCode }}</span>
        <br>
        <span>{{ building.management_company.address1 }}</span>
        <br>
        <span>{{ building.management_company.address2 }}</span>
        <div class="tel_area">
          <span v-if="building.management_company.tel">TEL:</span>
          <span>{{ building.management_company.tel }}</span>
          <br>
          <span v-if="building.management_company.fax">FAX:</span>
          <span>{{ building.management_company.fax }}</span>
        </div>
        <div v-if="building.management_company.use_invoice_number">
          <span>登録番号 </span>
          <span>{{ building.management_company.invoice_number }}</span>
        </div>
      </div>
    </div>
    <p class="reissue_txt" v-if="receipt_issued_status===$constant.RECEIPT_STATUS.RECEIPT_STATUS_REISSUE_DONE">再 発 行</p>
  </section>
  <section class="no-print mt-3">
    <print-button text="印刷" class="btn-primary" align="center" />
  </section>
  <section class="no-print_right mt-3">
    <close-button />
  </section>
</template>

<script>
import {mapState, mapMutations, mapGetters} from 'vuex';
import AddonLoadPageEvent from '@/mixin/AddonLoadPageEvent';
import CloseButton from '@/views/molecules/buttons/CloseButton';
import PrintButton from '@/views/molecules/buttons/PrintButton';
import moment from "moment";
import 'moment/locale/ja'

moment.locale('ja')

export default {
  name: 'ReceiptIssue',
  components: {
    CloseButton,
    PrintButton,
  },
  mixins: [AddonLoadPageEvent],
  provide: {
    bindModule: "issuance_request_form",
  },
  inject: [
    '$constant',
    '$moment'
  ],
  beforeRouteLeave() {
    this.resetData();
  },
  created() {
    this.loadPage(); // Vuexのデータを確実に取得する
  },
  computed: {
    ...mapState('issuance_request_form', {
      id: state => state.data.id,
      billing_price: state => state.data.billing_price,
      tax_price: state => state.data.tax_price,
      building_house_number: state => state.data.building_house_number,
      issue_document: state => state.data.issue_document,
      requester: state => state.data.requester,
      building: state => state.data.building,
      receipt_issued_count: state => state.data.receipt_issued_count,
      receipt_issued_at: state => state.data.receipt_issued_at,
      receipt_issued_status: state => state.data.receipt_issued_status,
      errors: state => state.errors,
    }),
    ...mapGetters('issuance_request_form', [
      'issueDocumentName'
    ]),
    formattedDate() {
      return moment(this.receipt_issued_at).format('LL');
    },
    formattedTodayDate() {
      const today = new Date();
      return moment(today).format('LL');
    },
    compactDate() {
      return this.formatToCompact(this.receipt_issued_at);
    },
    formattedPostalCode() {
      return this.formatPostalCode(this.building.management_company.postal_code)
    },
  },
  methods: {
    ...mapMutations('issuance_request_form', [
    ]),
    loadPage() {
      return this.$store.dispatch('issuance_request_form/load', {id: this.$route.params.id, printPreview: true}).then(() => {
        this.$root.showFlashMessage();
      }).catch(() => this.$root.failApi());
    },
    parseDate(date) {
      const datePart = new String(date).split(" ")[0]; // "2024-11-22"
      const [year, month, day] = datePart.split("-"); // [2024, 11, 22]
      return { year, month, day };
    },
    formatToCompact(date) {
      const { year, month, day } = this.parseDate(date);
      return `${year.slice(2)}${month}${day}`;
    },
    formatPostalCode(value) {
      if (!value || value.length !== 7) return value; // 値が無効な場合、そのまま返す
      return value.slice(0, 3) + "-" + value.slice(3);
    },
  },
}
</script>

<style lang="css" scoped>
  .print_page_1 {
    width: 950px;
    margin: 0 auto; /* 中央寄せ */
    position: relative;
    overflow: hidden; /* 不要なスクロールを防ぐ */
  }
  .title {
    font-size: 40px;
    letter-spacing: 10px;
    margin: 10px 0;
  }
  .top_area {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
  }
  .broker_name_area {
    margin-top: 40px;
    position: relative;
  }
  .name_area_flex {
    display: flex;
  }
  .underline_area {
    border-bottom: solid 1.5px;
    width: 380px;
    text-align: center;
  }
  .broker_name {
    font-size: 19px;
    bottom: 0;
    left: 0;
    width: 375px;
  }
  .broker_honorifics {
    font-size: 25px;
    position: absolute;
    bottom: 25px;
    left: 390px;
    width: 80px;
  }
  .issue_info_area {
    margin-top: 40px;
    margin-right: 40px;
  }
  .issue_date {
    margin-top: 15px;
  }
  .price_area {
    font-size: 27px;
    width: 700px;
    text-align: center;
    margin: 0 auto;
    background-color: darkgray;
    border-bottom: 3px double;
  }
  .text_bold {
    font-weight: bold;
    margin-right: 60px;
  }
  .text_area {
    font-size: 17px;
    margin-left:140px;
    margin-top: 15px;
    max-width: 680px;
  }
  .bottom_area {
    display: flex;
    justify-content: space-between;
    margin-top: 40px;
    position: relative;
  }
  .price_detail_area {
    margin-top: 30px;
    margin-left: 100px;
  }
  .detail_title {
    width: auto;
    border-bottom: solid 1.5px;
  }
  .detail_area {
    display: flex;
    justify-content: space-between;
  }
  .detail_price_area {
    display: flex;
    justify-content: space-between;
    width: 140px;
    margin-right: 20px;
  }
  .info_area {
    width: 250px;
  }
  .tel_area {
    margin-left: 20px;
  }
  .stamp_img_area {
    position: relative;
  }
  .stamp_img {
    position: absolute;
    max-width: 90px;
    max-height: 90px;
    top: -50px;
    right: 30px;
  }
  .no-print {
    text-align: center;
    position: absolute; /* fixed ではなく absolute に変更 */
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    width: 150px;
    z-index: 1000; /* 他の要素より前面に表示 */
  }
  .no-print_right {
    text-align: right;
    position: absolute; /* fixed ではなく absolute に変更 */
    bottom: 20px;
    left: 90%;
    transform: translateX(-50%);
    width: 150px;
    z-index: 1000; /* 他の要素より前面に表示 */
  }
  .reissue_txt {
    position: absolute;
    font-size: 30px;
    color: red;
    top: 30px;
    right: 50px;
  }
</style>